import { compose } from 'redux'
import { connect } from 'react-redux'
import { withHandlers, withProps } from 'recompose'
import { isSubmitting } from 'redux-form'
import registerReduxModal from 'components/common/hoc/registerReduxModal'
import ProvidePhoneNumberModal from './ProvidePhoneNumberModal'
import { PROVIDE_PHONE_NUMBER_MODAL } from './constants'
import {
  providePhoneNumber,
  submitProvidePhoneNumberForm,
  hideProvidedNumberPhoneModal
} from '../CommunicationPreferencesDrawer/actions'
import { PROVIDE_PHONE_NUMBER_FORM } from './components/ProvidePhoneNumberForm'

export {
  PROVIDE_PHONE_NUMBER_MODAL
}

const withProvidePhoneNumber = withHandlers({
  submitPhoneNumber: ({ dispatch }) => values => dispatch(providePhoneNumber(values)),
  closeProvidePhoneNumberModal: ({ dispatch }) => (e) => dispatch(hideProvidedNumberPhoneModal(e))
}
)

const withSubmitProvidePhoneNumberForm = withProps(() => ({ submitProvidePhoneNumberForm }))

const isProvidePhoneNumberFormSubmitting = isSubmitting(PROVIDE_PHONE_NUMBER_FORM)

export default compose(
  registerReduxModal({ name: PROVIDE_PHONE_NUMBER_MODAL }),
  connect(state => ({ isProvidePhoneNumberFormSubmitting: isProvidePhoneNumberFormSubmitting(state) })),
  withProvidePhoneNumber,
  withSubmitProvidePhoneNumberForm
)(ProvidePhoneNumberModal)
